import React, { useState, useEffect } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col } from "react-bootstrap";
import "./RelatedProperties.scss";
import { getSrc } from "gatsby-plugin-image"
import ImgCardDesktop1 from "../../../images/StaticPage/selling-property-d.png";
import ImgCardTablet1 from "../../../images/StaticPage/selling-property-d.png";
import ImgCardMobile1 from "../../../images/StaticPage/selling-property-d.png";

import ImgCardDesktop2 from "../../../images/StaticPage/buying-property-d.png";
import ImgCardTablet2 from "../../../images/StaticPage/buying-property-d.png";
import ImgCardMobile2 from "../../../images/StaticPage/buying-property-d.png";

import ImgCardDesktop3 from "../../../images/StaticPage/renting-property-d.png";
import ImgCardTablet3 from "../../../images/StaticPage/renting-property-d.png";
import ImgCardMobile3 from "../../../images/StaticPage/renting-property-d.png";

import ImgCardDesktop4 from "../../../images/StaticPage/tenants-property-d.png";
import ImgCardTablet4 from "../../../images/StaticPage/tenants-property-d.png";
import ImgCardMobile4 from "../../../images/StaticPage/tenants-property-d.png";

import { isMobile, isMobileTab } from '../../jsutility/index'

import GetURL from '@Components/common/site/get-url';
import ReactMarkdown from "react-markdown";
import Slider from "react-slick";
import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const RelatedProperties = (props) => {
    const settings = {
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots:true,
            },
          },
        ],
      }

    const RelatedPropertiesList = [
        {
            ImgDesktop: ImgCardDesktop1,
            ImgTablet: ImgCardTablet1,
            ImgMobile: ImgCardMobile1,
            ImgCaptionText: "Buying",
            listProp: [
                "Property for Sale",
                "Guide to Buying",
                "Investments",
                "Mortgages",
            ]

        },
        {
            ImgDesktop: ImgCardDesktop2,
            ImgTablet: ImgCardTablet2,
            ImgMobile: ImgCardMobile2,
            ImgCaptionText: "Selling",
            listProp: [
                "Ethical Sales",
                "Guide to Sales",
                "Property Valuation"
            ]
        },
        {
            ImgDesktop: ImgCardDesktop3,
            ImgTablet: ImgCardTablet3,
            ImgMobile: ImgCardMobile3,
            ImgCaptionText: "Landlords",
            listProp: [
                "Property Management",
                "Ethical Lettings",
                "Guide to Letting",
                "Property Valuation",
            ]
        },
        {
            ImgDesktop: ImgCardDesktop4,
            ImgTablet: ImgCardTablet4,
            ImgMobile: ImgCardMobile4,
            ImgCaptionText: "Tenants",
            listProp: [
                "Property to Let",
                "Ethical Renting",
                "Guide to Renting",
            ]
        },
    ];

    let [reviewList, setCustomerReview] = useState([]);
    let intialNumberOfReview = 4;

    useEffect(() => {
        if (isMobile()) {
            intialNumberOfReview = 1
        }
        else if (isMobileTab()) {
            intialNumberOfReview = 2
        }
    }, [])

    useEffect(() => {
        setCustomerReview(RelatedPropertiesList.slice(0, intialNumberOfReview));
    }, []);

    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <React.Fragment>
                        <section className="related-properties">
                            <Container>
                                <Row>
                                    <Col lg={12}>
                                        <div className="sub-child-desc">
                                            <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                                                <ReactMarkdown source={props.Content} allowDangerousHtml />
                                            </ScrollAnimation>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="mobile-view-only">
                                <Slider {...settings}>
                                {props.CTAS && props.CTAS.map((item, index) => (
                                        <div className="card-container-box" variants={items}>
                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                <div className="related-properties-card">
                                                    <div className="card-img-box">
                                                        <GetURL class="full-tail" label={item.CTA_1_label} alias={item.CTA_1_Url?.URL} />
                                                        <img src={getSrc(item.Image?.url_sharp)} alt={item.Image?.alternativeText} />
                                                        <div className="img-card-title">
                                                            <ul>
                                                                <li><GetURL label={item.CTA_1_label} alias={item.CTA_1_Url?.URL} /></li>
                                                            </ul>
                                                        </div>
                                                        <div className="btm-border-card"></div>
                                                    </div>

                                                    <div className="related-property-list">
                                                        <ul>
                                                            {item.Add_Sub_Cta.map((subitem) => (
                                                                <li><GetURL label={subitem.CTA_label} alias={subitem.CTA_Url?.URL} /></li>

                                                            ))}

                                                        </ul>
                                                    </div>
                                                </div>
                                            </ScrollAnimation>
                                        </div>
                                    ))}
                                    </Slider>
                                    </div>
                                    <div className="non-mobile-view-only">
                                <Row>
                                    {props.CTAS && props.CTAS.map((item, index) => (
                                        <MotionColumn md={6} xl={3} className="card-container-box" variants={items}>
                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                <div className="related-properties-card">
                                                    <div className="card-img-box">
                                                        <GetURL class="full-tail" label={item.CTA_1_label} alias={item.CTA_1_Url?.URL} />
                                                        <img src={getSrc(item.Image?.url_sharp)} alt={item.Image?.alternativeText} />
                                                        <div className="img-card-title">
                                                            <ul>
                                                                <li><GetURL label={item.CTA_1_label} alias={item.CTA_1_Url?.URL} /></li>
                                                            </ul>
                                                        </div>
                                                        <div className="btm-border-card"></div>
                                                    </div>

                                                    <div className="related-property-list">
                                                        <ul>
                                                            {item.Add_Sub_Cta.map((subitem) => (
                                                                <li><GetURL label={subitem.CTA_label} alias={subitem.CTA_Url?.URL} /></li>

                                                            ))}

                                                        </ul>
                                                    </div>
                                                </div>
                                            </ScrollAnimation>
                                        </MotionColumn>
                                    ))}
                                </Row>
                                </div>
                            </Container>
                        </section>
                    </React.Fragment>
                </motion.section>
            )}
        </InView>
    )
}

export default RelatedProperties;